(function () {
  const theme = window.emsTheme || {};
  const routes = theme.routes || window.routes || {};
  let lastSubmittedButton = null;

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency: 'CAD',
    }).format(amount);
  }

  function setButtonSuccess(button) {
    if (!button) return;
    const label = button.querySelector('span');
    const previous = label ? label.textContent : button.textContent;

    button.classList.add('is-success');
    if (label) {
      label.textContent = 'Added';
    } else {
      button.textContent = 'Added';
    }

    window.setTimeout(() => {
      button.classList.remove('is-success');
      if (label) {
        label.textContent = previous;
      } else {
        button.textContent = previous;
      }
    }, 1200);
  }

  function bumpCartCount() {
    window.setTimeout(() => {
      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        bubble.classList.remove('bump');
        bubble.offsetHeight;
        bubble.classList.add('bump');
        bubble.addEventListener('animationend', () => bubble.classList.remove('bump'), { once: true });
      });
    }, 80);
  }

  let cartCountRequest = null;

  async function syncEmsCartCount() {
    if (!routes.cart_url) return;
    if (!cartCountRequest) {
      cartCountRequest = fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to refresh cart count');
          return response.json();
        })
        .finally(() => {
          cartCountRequest = null;
        });
    }

    try {
      const cart = await cartCountRequest;
      const itemCount = Number(cart?.item_count || 0);
      document.querySelectorAll('[data-ems-cart-count]').forEach((count) => {
        count.textContent = String(itemCount);
      });
      document.querySelectorAll('[data-ems-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', `Cart, ${itemCount} ${itemCount === 1 ? 'item' : 'items'}`);
      });
    } catch {
      // Native Shopify cart UI remains functional if this enhancement cannot refresh.
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('product-form form, .ems-quick-order form');
      if (!form) return;
      lastSubmittedButton = event.submitter || form.querySelector('[type="submit"]');
    },
    true
  );

  if (window.PUB_SUB_EVENTS?.cartUpdate && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
      setButtonSuccess(lastSubmittedButton);
      bumpCartCount();
      syncEmsCartCount();
    });
  }

  function initPreferredCheckoutGuard() {
    const checkoutSelector = '[data-ems-preferred-checkout="true"]';
    if (!document.querySelector(checkoutSelector)) return;

    let boldCartReady = false;
    let staleBoldSignature = '';
    let failureTimer = null;

    function readBoldPlatformCustomer() {
      const dataNodes = document.querySelectorAll('#bold-platform-data');

      for (const dataNode of dataNodes) {
        try {
          const platformData = JSON.parse(dataNode.textContent || '{}');
          if (platformData?.customer?.id) return platformData.customer;
        } catch {
          // Keep checking in case another BOLD data node contains valid JSON.
        }
      }

      return null;
    }

    function hasLegacyBoldRuntime() {
      return typeof window.shappify_customer_tags !== 'undefined' && typeof window.shappify_csp_main === 'function';
    }

    function hasV3BoldRuntime() {
      const customer = readBoldPlatformCustomer();
      return Boolean(customer?.id && Array.isArray(customer.tags) && customer.tags.length);
    }

    function getBoldMarkers() {
      return Array.from(
        document.querySelectorAll(
          '#main-cart-footer .totals__total-value[data-cart-total], #main-cart-items .cart-item [data-line-index]'
        )
      );
    }

    function markerSignature(markers) {
      return markers
        .map((marker) => `${marker.dataset.lineIndex || 'total'}:${marker.textContent?.trim() || ''}`)
        .join('|');
    }

    function isVisibleV3Marker(marker) {
      return Boolean(
        marker &&
          marker.classList.contains('money') &&
          marker.classList.contains('pre-money') &&
          marker.style.visibility === 'visible'
      );
    }

    function hasProcessedV3Cart() {
      const cartItems = Array.from(document.querySelectorAll('#main-cart-items .cart-item'));
      const cartTotal = document.querySelector('#main-cart-footer .totals__total-value[data-cart-total]');

      if (!cartItems.length || !isVisibleV3Marker(cartTotal)) return false;

      return cartItems.every((cartItem) => {
        const itemPrice = cartItem.querySelector('.product-option.money.pre-money[data-line-index]');
        const lineTotal = cartItem.querySelector('.price.price--end.money.pre-money[data-line-index]');
        return isVisibleV3Marker(itemPrice) && isVisibleV3Marker(lineTotal);
      });
    }

    function hasFreshBoldMarkers() {
      const markers = getBoldMarkers();
      const customerPricingLoaded = hasLegacyBoldRuntime() || hasV3BoldRuntime();
      const cartProcessed = hasLegacyBoldRuntime() ? markers.length > 0 : hasProcessedV3Cart();
      const currentSignature = markerSignature(markers);
      return customerPricingLoaded && cartProcessed && currentSignature !== staleBoldSignature;
    }

    function setStatus(message) {
      document.querySelectorAll('[data-ems-preferred-checkout-status]').forEach((status) => {
        status.textContent = message;
        status.hidden = !message;
      });
    }

    function applyState() {
      document.querySelectorAll(checkoutSelector).forEach((button) => {
        button.toggleAttribute('disabled', !boldCartReady);
        if (boldCartReady) {
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('aria-disabled', 'true');
        }
      });
      setStatus(boldCartReady ? '' : 'Confirming preferred pricing...');
    }

    function showFailure() {
      if (boldCartReady) return;
      setStatus('Preferred pricing could not be confirmed. Refresh the cart or contact us before placing this order.');
    }

    function startFailureTimer() {
      window.clearTimeout(failureTimer);
      failureTimer = window.setTimeout(showFailure, 12000);
    }

    function markPending() {
      boldCartReady = false;
      staleBoldSignature = markerSignature(getBoldMarkers());
      applyState();
      startFailureTimer();
    }

    function markReadyIfConfirmed() {
      if (!hasFreshBoldMarkers()) return;
      boldCartReady = true;
      staleBoldSignature = '';
      window.clearTimeout(failureTimer);
      applyState();
    }

    document.addEventListener(
      'click',
      (event) => {
        const checkoutButton = event.target.closest(checkoutSelector);
        if (checkoutButton && !boldCartReady) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showFailure();
          return;
        }

        if (event.target.closest('cart-remove-button, [data-cart-remove]')) markPending();
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        if (event.target.matches('#cart') && event.submitter?.matches(checkoutSelector) && !boldCartReady) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showFailure();
        }
      },
      true
    );

    document.addEventListener(
      'change',
      (event) => {
        if (event.target.matches('[name^="updates"]')) markPending();
      },
      true
    );

    new MutationObserver(markReadyIfConfirmed).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-cart-total', 'data-line-index'],
      childList: true,
      subtree: true,
    });

    staleBoldSignature = '';
    applyState();
    markReadyIfConfirmed();
    startFailureTimer();
  }

  function selectProductTab(container, selectedTab) {
    const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

    tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.classList.toggle('ems-product-details__tab--active', isSelected);
    });

    panels.forEach((panel) => {
      panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
    });
  }

  function setupProductTabs(container) {
    if (!container || container.dataset.productTabsReady === 'true') return;
    const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    container.dataset.productTabsReady = 'true';

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectProductTab(container, tab));
    });

    container.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const current = tabs.indexOf(document.activeElement);
      if (current === -1) return;

      event.preventDefault();
      const nextIndex =
        event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? tabs.length - 1
            : event.key === 'ArrowRight'
              ? (current + 1) % tabs.length
              : (current - 1 + tabs.length) % tabs.length;

      tabs[nextIndex].focus();
      selectProductTab(container, tabs[nextIndex]);
    });
  }

  class EMSProductTabs extends HTMLElement {
    connectedCallback() {
      setupProductTabs(this);
    }
  }

  class EMSStickyAtc extends HTMLElement {
    connectedCallback() {
      this.anchor = document.getElementById('main-add-to-cart');
      this.footer = document.querySelector('footer, .shopify-section-group-footer-group');
      this.sectionId = this.dataset.mainFormId?.replace('product-form-', '');
      this.productInfo = this.closest('product-info') || document.querySelector(`product-info[data-section="${this.sectionId}"]`);
      this.mainForm = document.getElementById(this.dataset.mainFormId);
      this.mainQuantity = document.getElementById(this.dataset.mainQuantityId);
      this.variantInput = this.querySelector('input[name="id"]');
      this.quantityInput = this.querySelector('.ems-sticky-atc__qty');
      this.submitButton = this.querySelector('[type="submit"]');
      this.price = this.querySelector('[data-sticky-atc-price]');
      this.priceRoot = this.sectionId ? document.getElementById(`price-${this.sectionId}`) : null;
      this.variantLabel = this.querySelector('[data-sticky-atc-variant]');
      this.status = this.querySelector('[data-sticky-atc-status]');
      this.codeBlocks = Array.from(document.querySelectorAll('[data-ems-product-code]'));
      this.codeValues = Array.from(document.querySelectorAll('[data-ems-product-code-value]'));
      this.variants = this.readVariants();
      this.footerVisible = false;
      this.mainAtcPassed = false;
      this.stickyRevealOffset = 80;

      this.syncFromMainForm();
      this.bindQuantitySync();
      this.observeVisibility();
      this.bindVariantUpdates();
      this.observePriceChanges();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.visibilityHandler);
      window.removeEventListener('resize', this.visibilityHandler);
      this.variantChangeUnsubscriber?.();
      this.priceObserver?.disconnect();
      if (this.mainVariantInputChangeHandler) {
        document.removeEventListener('change', this.mainVariantInputChangeHandler);
      }
    }

    readVariants() {
      try {
        const json = this.querySelector('[data-sticky-atc-variants]')?.textContent || '[]';
        return JSON.parse(json);
      } catch {
        return [];
      }
    }

    bindQuantitySync() {
      if (this.mainQuantity && this.quantityInput) {
        this.mainQuantity.addEventListener('change', () => {
          this.quantityInput.value = this.mainQuantity.value;
        });
        this.quantityInput.addEventListener('change', () => {
          this.mainQuantity.value = this.quantityInput.value;
          this.mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    observeVisibility() {
      if (!this.anchor) return;

      this.visibilityHandler = () => {
        const anchorBottom = this.anchor.getBoundingClientRect().bottom;
        const footerTop = this.footer?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
        this.mainAtcPassed = anchorBottom <= this.stickyRevealOffset;
        this.anchorVisible = !this.mainAtcPassed;
        this.footerVisible = footerTop <= window.innerHeight * 0.3;
        this.updateVisibility();
      };

      window.addEventListener('scroll', this.visibilityHandler, { passive: true });
      window.addEventListener('resize', this.visibilityHandler);
      this.visibilityHandler();
    }

    updateVisibility() {
      this.classList.toggle('is-visible', this.mainAtcPassed && !this.anchorVisible && !this.footerVisible);
    }

    bindVariantUpdates() {
      this.mainVariantInputChangeHandler = (event) => {
        const form = event.target?.closest?.('form');
        if (form?.getAttribute('id') === this.dataset.mainFormId && event.target?.name === 'id') {
          this.syncFromMainForm();
        }
      };
      document.addEventListener('change', this.mainVariantInputChangeHandler);

      if (window.PUB_SUB_EVENTS?.variantChange && typeof window.subscribe === 'function') {
        this.variantChangeUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId && this.sectionId && event.data.sectionId !== this.sectionId) return;
          this.updateVariant(event?.data?.variant);
          this.syncPriceFromDomSoon();
        });
      }
    }

    syncFromMainForm() {
      this.mainForm = document.getElementById(this.dataset.mainFormId);
      const selectedVariant = this.readSelectedVariant();
      const variantId =
        this.mainForm?.querySelector('input[name="id"]')?.value || selectedVariant?.id || this.dataset.selectedVariantId;
      const variant = this.variants.find((item) => String(item.id) === String(variantId)) || selectedVariant;
      this.updateVariant(variant);
    }

    readSelectedVariant() {
      try {
        const json = this.productInfo?.querySelector('variant-selects [data-selected-variant]')?.textContent;
        return json ? JSON.parse(json) : null;
      } catch {
        return null;
      }
    }

    updateVariant(variant) {
      if (!variant) return;
      this.currentFallbackPrice = variant.price;
      if (this.variantInput) {
        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;
      }
      if (this.variantLabel) this.variantLabel.textContent = variant.public_title || variant.title || '';
      if (this.status) {
        this.status.textContent = variant.available ? 'In stock' : 'Unavailable';
        this.status.dataset.available = variant.available ? 'true' : 'false';
      }
      if (this.submitButton) this.submitButton.toggleAttribute('disabled', !variant.available);
      this.updateProductCode(variant);
      this.updatePrice(variant.price);
    }

    syncPriceFromDomSoon() {
      const syncPrice = () => this.updatePrice(this.currentFallbackPrice);
      window.requestAnimationFrame?.(syncPrice) || window.setTimeout(syncPrice, 0);
      window.setTimeout(syncPrice, 120);
    }

    observePriceChanges() {
      if (!this.priceRoot) return;

      this.priceObserver = new MutationObserver(() => this.updatePrice(this.currentFallbackPrice));
      this.priceObserver.observe(this.priceRoot, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        characterData: true,
        childList: true,
        subtree: true,
      });
    }

    updateProductCode(variant) {
      const hasSku = Boolean(variant.sku);
      this.codeBlocks.forEach((codeBlock) => {
        codeBlock.hidden = !hasSku;
      });
      this.codeValues.forEach((codeValue) => {
        codeValue.textContent = variant.sku || '';
      });
    }

    updatePrice(fallbackPrice) {
      const priceContainer = this.priceRoot?.querySelector('.price');
      const boldPriceText =
        priceContainer?.matches('.money[data-product-id], .money.pre-money') &&
        priceContainer.style.visibility !== 'hidden'
          ? priceContainer.textContent?.trim()
          : '';
      const livePrice = priceContainer?.classList.contains('price--on-sale')
        ? priceContainer.querySelector('.price__sale .price-item--sale')
        : priceContainer?.querySelector('.price__regular .price-item--regular');
      const liveText = boldPriceText || livePrice?.textContent?.trim();
      if (this.price && (liveText || fallbackPrice !== undefined)) this.price.textContent = liveText || formatMoney(fallbackPrice);
    }
  }

  class EMSQuickOrderPad extends HTMLElement {
    connectedCallback() {
      this.rowsEl = this.querySelector('[data-ems-quick-order-rows]');
      this.template = this.querySelector('[data-ems-quick-order-row-template]');
      this.summary = this.querySelector('[data-ems-quick-order-summary]');
      this.addAllButton = this.querySelector('[data-ems-quick-order-add-all]');
      this.pasteInput = this.querySelector('[data-ems-quick-order-paste]');
      this.queryCache = new Map();

      this.querySelector('[data-ems-quick-order-add-row]')?.addEventListener('click', () => this.addRow());
      this.querySelector('[data-ems-quick-order-parse]')?.addEventListener('click', () => this.applyPaste());
      this.querySelector('[data-ems-quick-order-close]')?.addEventListener('click', () => this.hide());
      this.addAllButton?.addEventListener('click', () => this.addAllToCart());
      this.addRow();
      this.updateSummary();
    }

    show() {
      this.hidden = false;
      this.querySelector('[data-ems-quick-order-sku]')?.focus();
    }

    hide() {
      this.hidden = true;
    }

    addRow(data = {}) {
      const row = this.template.content.firstElementChild.cloneNode(true);
      const sku = row.querySelector('[data-ems-quick-order-sku]');
      const qty = row.querySelector('[data-ems-quick-order-qty]');
      sku.value = data.sku || '';
      qty.value = data.qty || 1;
      sku.addEventListener('input', this.debounce(() => this.resolveRow(row), 300));
      qty.addEventListener('change', () => this.updateRowTotal(row));
      row.querySelector('[data-ems-quick-order-remove]')?.addEventListener('click', () => {
        row.remove();
        if (!this.rowsEl.children.length) this.addRow();
        this.updateSummary();
      });
      this.rowsEl.append(row);
      if (data.sku) this.resolveRow(row);
      return row;
    }

    applyPaste() {
      const lines = (this.pasteInput?.value || '').split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
      if (!lines.length) return;
      this.rowsEl.innerHTML = '';
      lines.forEach((line) => {
        const [sku, qty] = line.split(/[\t,;]/).map((value) => value.trim());
        this.addRow({ sku, qty: Number(qty) > 0 ? Number(qty) : 1 });
      });
    }

    async resolveRow(row) {
      const sku = row.querySelector('[data-ems-quick-order-sku]').value.trim();
      row.dataset.variantId = '';
      row.dataset.price = '';
      row.classList.remove('ems-quick-order__row--resolved', 'ems-quick-order__row--invalid');
      this.setStatus(row, sku ? 'Searching...' : 'Enter a SKU');
      if (!sku) {
        this.updateSummary();
        return;
      }

      const variant = await this.findVariantBySku(sku);
      if (!variant) {
        row.classList.add('ems-quick-order__row--invalid');
        this.setStatus(row, 'SKU not found');
        row.querySelector('[data-ems-quick-order-price]').textContent = '';
        this.updateSummary();
        return;
      }

      if (!variant.available) {
        row.classList.add('ems-quick-order__row--invalid');
        this.setStatus(row, `${variant.productTitle} · unavailable`);
        row.querySelector('[data-ems-quick-order-price]').textContent = formatMoney(variant.price);
        this.updateSummary();
        return;
      }

      row.dataset.variantId = variant.id;
      row.dataset.price = variant.price;
      row.classList.add('ems-quick-order__row--resolved');
      this.setStatus(row, `${variant.productTitle} · in stock`);
      this.updateRowTotal(row);
    }

    async findVariantBySku(sku) {
      const normalized = sku.toLowerCase();
      if (this.queryCache.has(normalized)) return this.queryCache.get(normalized);

      const handles = await this.searchProductHandles(sku);
      for (const handle of handles) {
        const product = await this.fetchProduct(handle);
        const match = product?.variants?.find((variant) => (variant.sku || '').toLowerCase() === normalized);
        if (match) {
          const result = {
            id: match.id,
            sku: match.sku,
            title: match.public_title || match.title,
            price: Number(match.price),
            available: match.available,
            productTitle: product.title,
          };
          this.queryCache.set(normalized, result);
          return result;
        }
      }

      this.queryCache.set(normalized, null);
      return null;
    }

    async searchProductHandles(sku) {
      if (!routes.predictive_search_url) return [];
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(sku)}&resources[type]=product&resources[limit]=8`;
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const handles = new Set();
      html.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        const path = new URL(link.href, window.location.origin).pathname;
        const handle = path.split('/products/')[1]?.split(/[/?#]/)[0];
        if (handle) handles.add(handle);
      });
      return Array.from(handles);
    }

    async fetchProduct(handle) {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      return response.json();
    }

    updateRowTotal(row) {
      const price = Number(row.dataset.price || 0);
      const qty = Number(row.querySelector('[data-ems-quick-order-qty]').value || 1);
      row.querySelector('[data-ems-quick-order-price]').textContent = price ? formatMoney(price * qty) : '';
      this.updateSummary();
    }

    setStatus(row, message) {
      row.querySelector('[data-ems-quick-order-status]').textContent = message;
    }

    validRows() {
      return Array.from(this.rowsEl.querySelectorAll('[data-ems-quick-order-row]')).filter((row) => row.dataset.variantId);
    }

    updateSummary() {
      const rows = this.validRows();
      const total = rows.reduce((sum, row) => {
        const qty = Number(row.querySelector('[data-ems-quick-order-qty]').value || 1);
        return sum + Number(row.dataset.price || 0) * qty;
      }, 0);
      if (this.summary) this.summary.textContent = `${rows.length} valid item${rows.length === 1 ? '' : 's'} · ${formatMoney(total)}`;
      this.addAllButton?.toggleAttribute('disabled', rows.length === 0);
    }

    async addAllToCart() {
      const items = this.validRows().map((row) => ({
        id: Number(row.dataset.variantId),
        quantity: Number(row.querySelector('[data-ems-quick-order-qty]').value || 1),
      }));
      if (!items.length || !routes.cart_add_url) return;

      this.addAllButton.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer');
      const body = { items };
      if (cart?.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const parsed = await response.json();
      this.addAllButton.classList.remove('is-loading');

      if (parsed.status) {
        this.summary.textContent = parsed.description || 'Unable to add those SKUs.';
        return;
      }

      setButtonSuccess(this.addAllButton);
      bumpCartCount();
      syncEmsCartCount();
      if (cart?.renderContents && parsed.sections) cart.renderContents(parsed);
      this.summary.textContent = `${items.length} item${items.length === 1 ? '' : 's'} added`;
    }

    debounce(callback, wait) {
      let timeout;
      return (...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => callback.apply(this, args), wait);
      };
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ems-quick-order-trigger]');
    if (!trigger) return;
    const target = document.getElementById(trigger.dataset.emsQuickOrderTarget || 'QuickOrder-header');
    target?.show?.();
  });

  function initRecentlyViewed() {
    const productInfo = document.querySelector('product-info[data-product-id]');
    if (!productInfo) return;
    try {
      const items = JSON.parse(localStorage.getItem('emsRecentlyViewed') || '[]').filter(
        (item) => item.id !== productInfo.dataset.productId
      );
      items.unshift({ id: productInfo.dataset.productId, url: productInfo.dataset.url, at: Date.now() });
      localStorage.setItem('emsRecentlyViewed', JSON.stringify(items.slice(0, 12)));
    } catch {
      localStorage.removeItem('emsRecentlyViewed');
    }
  }

  function initProductTabs() {
    document.querySelectorAll('[data-product-tabs]').forEach(setupProductTabs);
  }

  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  document.addEventListener('DOMContentLoaded', initProductTabs);
  document.addEventListener('DOMContentLoaded', initPreferredCheckoutGuard);

  if (!customElements.get('ems-sticky-atc')) customElements.define('ems-sticky-atc', EMSStickyAtc);
  if (!customElements.get('ems-quick-order-pad')) customElements.define('ems-quick-order-pad', EMSQuickOrderPad);
  if (!customElements.get('ems-product-tabs')) customElements.define('ems-product-tabs', EMSProductTabs);
})();
